import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, InputAdornment, Paper, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import kitchenTips from '../../content/cleaning-tips/categories/kitchen.json';

const TipsHeader = () => {
  const [featuredTip, setFeaturedTip] = useState(null);

  useEffect(() => {
    const featured = kitchenTips.find(tip => tip.featured);
    setFeaturedTip(featured);
  }, []);

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
        Expert Cleaning Tips from the Pros
      </Typography>
      <Typography variant="h5" component="h2" sx={{ mb: 4 }}>
        Keep your home spotless between professional cleanings
      </Typography>
      <TextField
        id="search-tips"
        placeholder="Search for a tip..."
        variant="filled"
        fullWidth
        sx={{ maxWidth: '600px', mx: 'auto', mb: 4, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: 1 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
      {featuredTip && (
        <Paper sx={{ p: 2, maxWidth: '600px', mx: 'auto', backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
          <Typography variant="h6" gutterBottom>Featured Tip:</Typography>
          <Typography variant="body1" gutterBottom>{featuredTip.title}</Typography>
          <Button variant="contained" color="secondary" sx={{ mt: 1 }}>
            Read More
          </Button>
        </Paper>
      )}
    </Box>
  );
};

export default TipsHeader;
